"use client";

import React from "react";
import {PageCompetitionBookSchema} from "@/sanity/pages/PageCompetitionBookTemplate";

import Image from "next/image";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {CTACornerButton} from "@/shadcn/ui/corner-button";
import Chip from "@/components/global/ui/Chip";

import bg from "@/public/competition-book-ty/last-bg.jpg";

export default function LastSection({
  data,
  className
}: {
  data: PageCompetitionBookSchema;
  className?: string;
}) {
  return (
    <section className={cn(
      "relative overflow-clip pt-[19rem] pb-[34rem] lg:pb-[40rem] lg:pt-[33rem] -mt-[3rem]",
      className
    )}>
      <div className="absolute top-0 h-full left-1/2 -translate-x-1/2 !w-[max(100%,200rem)] pointer-events-none">
        <div className="relative w-full h-full">
          <Image
            className="!w-full !h-full object-cover max-w-none"
            src={bg}
            alt="dubai background image"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#0A1A1D] to-transparent to-[120%]" />
        </div>
      </div>

      <div className="container flex flex-col items-center relative">
        <Chip
          className="prose-img:!w-[3rem]"
          image={data?.lastChip?.icon}
          text={data?.lastChip?.text}
        />

        {data?.lastText && (
          <div className="richtext prose-p:w-[min(68.25rem,100%)] prose-p:text-white/60 prose-p:font-light prose-h2:mb-[3rem] prose-h2:w-[min(125rem,100%)] prose-h2:!font-ivy prose-h2:!text-[5rem] sm:prose-h2:!text-[8rem] lg:prose-h2:!text-[12rem] prose-h2:leading-none prose-h2:italic prose-h2:text-transparent prose-h2:bg-clip-text prose-h2:bg-gradient-to-b prose-h2:from-white prose-h2:to-white/60">
            <PortableText
              value={data.lastText}
              components={richTextComponent}
            />
          </div>
        )}

        <hr className="border-t border-t-white/20 w-[min(75rem,100%)] my-[3rem]" />

        {data?.lastCTA && (
          <CTACornerButton
            className="[&_button]:!text-[2rem] lg:[&_button]:!text-[2.25rem]"
            data={data.lastCTA}
          />
        )}
      </div>
    </section>
  );
}
